import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=77c1b801&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c1b801"]])

export default __exports__